// extracted by mini-css-extract-plugin
export default {"bar":"FlowHealthBar_bar__sI2KT","error":"FlowHealthBar_error__2bVDP","ok":"FlowHealthBar_ok__2EEfF","unknown":"FlowHealthBar_unknown__1pVDa"};